const Keys = {
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight'
};

export default Keys;